// @ts-nocheck
/* eslint-disable */
/* NOTE: Auto-generated. Run `yarn build-icons` instead of editing. */
import { ReactComponent as ArrowRightDefault } from '../../../assets/icons/default/arrows/arrow-right.svg?react';
import { ReactComponent as ArrowRightSolid } from '../../../assets/icons/solid/arrows/ARROW-RIGHT.svg?react';
import { createIcons } from '../../Icon';
const ArrowRightIcon = /* @__PURE__ */ createIcons('ArrowRight', {
    default: ArrowRightDefault,
    solid: ArrowRightSolid
});
ArrowRightIcon.supportedTypes = ['default', 'solid'];
ArrowRightIcon.category = 'arrows';
export default ArrowRightIcon;
